export default "__VITE_PUBLIC_ASSET__88ec18ad__"